import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { IPonderacion, IResCrearPonderacion, IResValidarNotas } from 'src/app/interfaces/ponderaciones';
import { NgxSpinnerService } from 'ngx-spinner';
import { PonderacionesService } from 'src/app/services/ponderaciones/ponderaciones.service';
import { FormBuilder } from '@angular/forms';
import { ICalificacion, IExamen } from 'src/app/interfaces/ponderaciones';
import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-view-ponderacion-individual-editar',
  templateUrl: './view-ponderacion-individual-editar.component.html',
  styleUrls: ['./view-ponderacion-individual-editar.component.scss']
})
export class ViewPonderacionIndividualEditarComponent {
  ponderacionIdDp: number = 0;
  calificacionesParcialesDp: Array<ICalificacion> = []
  calificacionesExamenesDp: Array<IExamen> = []
  activarExamenExtraordinarioDp: boolean = false;

  ponderacionPCPDp: number = 60
  ponderacionPCETPd: number = 40

  minParcialesDp: number = 1
  maxParcialesDp: number = 20

  minExamenesDp: number = 0
  maxExamenesDp: number = 2

  cantidadCajasParcialesDp: number = 0
  cantidadCajasExamenesDp: number = 0

  infoModalTituloDp: string = ''
  infoModalTextoDp: string = ''

  filtroDp: any = {
    anyo: 0,
    periodo: {
      periodoAcademicoId: 0,
      periodoDescripcion: ""
    },
    sede: {
      sedeId: 0,
      descripcion: ""
    },
    asignatura: {
      id: 0,
      codigo: ""
    },
    seccion: {
      id: 0,
      descSeccion: ""
    }
  };

  datosConfiguracionDp: any = {};

  configDataDp: any = null;
  filtrosInicioDp: any = {

  }

  textoError: string = ''

  constructor(
    private formBuilder: FormBuilder,
    private _ponderaciones: PonderacionesService,
    private spinner: NgxSpinnerService,
    private _perfilamiento: PerfilamientoService,
    private router: Router
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if (routerData?.configuracion) {
      this.configDataDp = routerData.configuracion
      Object.keys(this.configDataDp).forEach(
        (key: any, i) => {
          if (key == "ponderacionId") {
            this.ponderacionIdDp = this.configDataDp[key];
            if (this.ponderacionIdDp === 0) {
              this.router.navigateByUrl('/ponderacion-individual-inicio');
            }
          } else {
            this.filtrosInicioDp[key] = this.configDataDp[key];
          }
        }
      )
    } else {
      this.router.navigateByUrl('/ponderacion-individual-inicio')
    }
  }

  volverInicio(): void {
    let configuracion = this.filtrosInicioDp
    this.router.navigate(['/ponderacion-individual-inicio'], { state: { data: { configuracion: configuracion } } })
  }

  ngOnInit() {
    this._ponderaciones.obtenerPonderacionIndividual(this.ponderacionIdDp).subscribe({
      next: (res: IPonderacion) => {
        this.datosConfiguracionDp = res;
        this.filtroDp.anyo = res.configuracion.anyo;
        this.filtroDp.periodo.periodoAcademicoId = res.configuracion.periodoId;
        this.filtroDp.sede.sedeId = res.configuracion.sedeId;
        this.filtroDp.asignatura.id = res.configuracion.asignaturaId;
        this.filtroDp.seccion.id = res.configuracion.seccionId;
        this.seleccionFiltro("anyo");
        this.minParcialesDp = res.cantidadNotas;
        this.ponderacionPCETPd = res.ponderacionPCET;
        this.ponderacionPCPDp = res.ponderacionPCP;
        for (let index = 0; index < this.minParcialesDp; index++) {
          let porcentaje = { porcentaje: res.promedioNotas[index].porcentaje }
          this.calificacionesParcialesDp[res.promedioNotas[index].numeroNota - 1] = porcentaje;
          // this.calificacionesParcialesDp = [...this.calificacionesParcialesDp,porcentaje]
          this.cantidadCajasParcialesDp = this.calificacionesParcialesDp.length;
        }
        this.minExamenesDp = res.cantidadExamenes;
        for (let index = 0; index < this.minExamenesDp; index++) {
          const porcentaje = { porcentajeE: res.promedioExamenes[index].porcentaje }
          this.calificacionesExamenesDp[res.promedioExamenes[index].numeroNota - 1] = porcentaje;
          // this.calificacionesExamenesDp = [...this.calificacionesExamenesDp, porcentaje]
          this.cantidadCajasExamenesDp = this.calificacionesExamenesDp.length
        }
        this.activarExamenExtraordinarioDp = res.examenExtraordinario;

      }
    })

  }

  getSedes(anyo: number, periodo: number, asignatura: number, sedeId: number) {

    if (sedeId == 0) {
      this.filtroDp.sede = {
        sedeId: sedeId,
        descripcion: ""
      }
    } else {
      this._ponderaciones.getFiltrosSedesSigla(this._perfilamiento.getUsuario()?.usuarioId,
        Number(anyo),
        Number(periodo),
        Number(asignatura)
      ).subscribe(
        (res: any) => {
          res.sedes.forEach((sede: any) => {
            if (sede.sedeId == sedeId) {
              this.filtroDp.sede = {
                sedeId: sedeId,
                descripcion: sede.descripcion
              }
            }
          })
          this.seleccionFiltro("sede");
        }, err => {
        }
      )
    }
  }

  getPeriodos(anyo: number, periodoId: number): void {
    this._ponderaciones.getFiltrosPeriodos(anyo).subscribe(
      (res: any) => {
        res.periodos.forEach((periodo: any) => {
          if (periodo.periodoAcademicoId == periodoId) {
            this.filtroDp.periodo = {
              periodoAcademicoId: periodoId,
              periodoDescripcion: periodo.periodoDescripcion
            }
            this.seleccionFiltro("periodo")
          }
        })
      }
    )
  }

  getAsignaturas(anyo: number, periodoId: number, sedeId: number, asignaturaId: number) {
    this._ponderaciones.getFiltrosAsignaturas({
      anyo: anyo,
      periodoId: periodoId,
      sedeId: sedeId
    }).subscribe(
      (res: any) => {
        res.asignaturas.forEach((asignatura: any) => {
          if (asignatura.id == asignaturaId) {
            this.filtroDp.asignatura = {
              id: asignatura.id,
              codigo: asignatura.codigo
            }
            this.seleccionFiltro("asignatura")
          }
        })
      }
    )
  }

  getSecciones(anyo: number, periodoId: number, sedeId: number, asignaturaId: number, seccionId: number) {
    this._ponderaciones.getFiltrosSecciones({
      anyo,
      periodoId,
      sedeId,
      asignaturaId
    }).subscribe(
      (res: any) => {
        res.secciones.forEach((seccion: any) => {
          if (seccion.id == seccionId) {
            this.filtroDp.seccion = {
              id: seccionId,
              descSeccion: seccion.descSeccion
            }
          }
        })
      }
    )
  }

  seleccionFiltro(filtro: string = '') {

    switch (filtro) {
      case 'anyo':
        this.getPeriodos(this.filtroDp.anyo, this.filtroDp.periodo.periodoAcademicoId);
        break;
      case 'periodo':
        this.getAsignaturas(this.filtroDp.anyo, this.filtroDp.periodo.periodoAcademicoId, this.filtroDp.sede.sedeId, this.filtroDp.asignatura.id);
        break;
      case 'asignatura':
        this.getSedes(this.filtroDp.anyo, this.filtroDp.periodo.periodoAcademicoId, this.filtroDp.asignatura.id, this.filtroDp.sede.sedeId);
        break;
      case 'sede':
        this.getSecciones(this.filtroDp.anyo, this.filtroDp.periodo.periodoAcademicoId, this.filtroDp.sede.sedeId, this.filtroDp.asignatura.id, this.filtroDp.seccion.id);
        break;
      case 'escuela':
        break;
      case 'carrera':
        break;

      default:
        break;
    }
  }

  agregarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParcialesDp = [...this.calificacionesParcialesDp, { porcentaje: 0 }]
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenesDp = [...this.calificacionesExamenesDp, { porcentajeE: 100 }]
        break;
      default:
        break;
    }
  }

  quitarCalif(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        this.calificacionesParcialesDp.pop()
        break;
      case 'calificacionesExamenes':
        this.calificacionesExamenesDp.pop()
        if (this.calificacionesExamenesDp.length === 0) {
          this.ponderacionPCETPd = 0
          this.ponderacionPCPDp = 100
        }
        break;
      default:
        break;
    }
  }

  totalParciales() {
    let porcentaje: number = 0
    this.calificacionesParcialesDp.forEach((calificacion: ICalificacion) => {
      porcentaje += calificacion.porcentaje
    })
    return porcentaje
  }

  totalExamenes() {
    let porcentajeEx: number = 0
    this.calificacionesExamenesDp.forEach((calificacion: IExamen) => {
      porcentajeEx += calificacion.porcentajeE
    })
    return porcentajeEx
  }

  switchExamenExtraordinario() {
    this.activarExamenExtraordinarioDp = !this.activarExamenExtraordinarioDp;
  }

  totalPonderacionPromedio() {
    let total: number = 0
    if (this.calificacionesExamenesDp.length > 0) {
      total = this.ponderacionPCETPd + this.ponderacionPCPDp
    } else {
      total = this.ponderacionPCPDp
    }
    return total;
  }

  ingresoCajasPonderaciones(tipo: string) {
    switch (tipo) {
      case 'calificacionesParciales':
        if (this.cantidadCajasParcialesDp >= this.maxParcialesDp) {
          this.cantidadCajasParcialesDp = this.maxParcialesDp
        }
        this.calificacionesParcialesDp = [];
        for (let index = 0; index < this.cantidadCajasParcialesDp; index++) {
          this.calificacionesParcialesDp = [...this.calificacionesParcialesDp, { porcentaje: 0 }]
        }
        break;
      case 'calificacionesExamenes':
        if (this.cantidadCajasExamenesDp >= this.maxExamenesDp) {
          this.cantidadCajasExamenesDp = this.maxExamenesDp
        }
        this.calificacionesExamenesDp = [];
        for (let index = 0; index < this.cantidadCajasExamenesDp; index++) {
          this.calificacionesExamenesDp = [...this.calificacionesExamenesDp, { porcentajeE: 0 }]
        }
        break;
      default:
        break;
    }
  }

  modalFaltaPonderacion() {
    this.infoModalTituloDp = 'Aviso'
    this.infoModalTextoDp = 'Debes completar todas las ponderaciones de las calificaciones agregadas <br> <span>Las ponderaciones no deben ser 0</span>'
    document.getElementById('btn-modal-info')?.click()
  }

  limpiarTextoError() {
    document.getElementById('idBreadcrumb')?.scrollIntoView()
    setTimeout(() => {
      this.textoError = ''
    }, 15000);
  }

  modalAvisoTotalCalificaciones(texto: string = 'El total de las ponderaciones de las calificaciones parciales debe ser 100%') {
    this.textoError = texto
    this.limpiarTextoError()
  }

  modalPonderacionCreada() {
    this.infoModalTituloDp = 'Exito'
    this.infoModalTextoDp = 'La ponderación ha sido creada exitosamente. Serás redireccionado...'
    document.getElementById('btn-modal-info')?.click()
  }

  modalValidacionPcet() {
    this.textoError = 'El Promedio examen (PCET) no puede ser 0 cuando existe 1 o más exámenes'
    this.limpiarTextoError()
  }

  modalPonderacionPromedios() {
    this.textoError = 'La Ponderación Promedios debe ser 100. El % Promedio examen (PCET) puede ser 0 cuando la cantidad de exámenes es 0'
    this.limpiarTextoError()
  }

  validarPonderaciones() {
    const parcialesEnCero = this.calificacionesParcialesDp.filter((parcial: any) => parcial.porcentaje === 0)
    const examenesEnCero = this.calificacionesExamenesDp.filter((examen: any) => examen.porcentajeE === 0)
    let promedioCalificacionesParciales: number = 0
    let promedioCalificacionesExamenes: number = 0
    this.calificacionesParcialesDp.forEach((parcial: any) => {
      promedioCalificacionesParciales += parcial.porcentaje
    })
    this.calificacionesExamenesDp.forEach((examen: any) => {
      promedioCalificacionesExamenes += examen.porcentajeE
    })
    if (parcialesEnCero.length > 0 || examenesEnCero.length > 0) {
      this.modalFaltaPonderacion()
      return false
    }
    if (this.calificacionesExamenesDp.length > 0 && this.ponderacionPCETPd === 0) {
      this.modalValidacionPcet()
      return false
    }
    if (promedioCalificacionesParciales !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones de las calificaciones parciales debe ser 100%')
      return false
    }
    if (this.calificacionesExamenesDp.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones del examen debe ser 100%')
      return false
    }
    if (this.calificacionesExamenesDp.length > 0 && promedioCalificacionesExamenes !== 100) {
      this.modalAvisoTotalCalificaciones('El total de las ponderaciones del examen debe ser 100%')
      return false
    }
    if (this.calificacionesExamenesDp.length > 0 && (this.ponderacionPCETPd + this.ponderacionPCPDp !== 100)) {
      this.modalPonderacionPromedios()
      return false
    }
    if ((this.calificacionesExamenesDp.length === 0 && this.ponderacionPCPDp !== 100) || this.ponderacionPCPDp === 0) {
      this.modalPonderacionPromedios()
      return false
    }
    return true
  }

  validarNotas(): void {
    if (!this.validarPonderaciones()) {
      return
    }
    this._ponderaciones.validarNotas(
      this.filtroDp.anyo,
      this.filtroDp.periodo.periodoAcademicoId,
      this.filtroDp.sede.sedeId,
      this.filtroDp.seccion.id
    ).subscribe(
      (res: IResValidarNotas) => {
        if ( res.error === null ) {
          if ( !res.valor || this.configDataDp?.estado === 'C' ) {
            this.guardar()
          } else {
            document.getElementById('modal-notas-ingresadas-btn')?.click()
          }
        } else {
          this.infoModalTituloDp = 'Aviso'
          this.infoModalTextoDp = res?.error?.mensaje ?? 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }
    )
  }

  fnNotaTmp(element: any, index: any): any {
    let notaTmp: any;
    if (index < this.datosConfiguracionDp.promedioNotas.length) {
      notaTmp = this.datosConfiguracionDp.promedioNotas[index]
      notaTmp.porcentaje = element.porcentaje;
    } else {
      notaTmp = Object.assign({}, this.datosConfiguracionDp.promedioNotas[0])
      notaTmp.porcentaje = element.porcentaje;
      notaTmp.numeroNota = index + 1;
    }
    return notaTmp
  }

  fnNotasExamenes(): any {
    let notasExamenes: Array<any> = []
    let notasExtraordinario: Array<any> = [];
    this.calificacionesExamenesDp.forEach((element, index) => {
      let notaTmp: any;
      let extraordinarioTmp: any;
      if (index < this.datosConfiguracionDp.promedioExamenes.length) {
        notaTmp = this.datosConfiguracionDp.promedioExamenes[index]
        notaTmp.porcentaje = element.porcentajeE;
        if (this.activarExamenExtraordinarioDp) {
          extraordinarioTmp = Object.assign({}, this.datosConfiguracionDp.promedioExamenesExtraordinario[index])
          extraordinarioTmp.porcentaje = element.porcentajeE;
          extraordinarioTmp.numeroNota = index + 1;
        }
      } else {
        notaTmp = Object.assign({}, this.datosConfiguracionDp.promedioExamenes[0])
        notaTmp.porcentaje = element.porcentajeE;
        notaTmp.numeroNota = index + 1;
        notaTmp.detallePonderacionId = null;
        if (this.activarExamenExtraordinarioDp) {
          extraordinarioTmp = Object.assign({}, this.datosConfiguracionDp.promedioExamenesExtraordinario[0])
          extraordinarioTmp.porcentaje = element.porcentajeE;
          extraordinarioTmp.numeroNota = index + 1;
          extraordinarioTmp.detallePonderacionId = null;
        }
      }
      notaTmp.tipoNota = "CE";
      notaTmp.ponderacionBaseId = this.ponderacionIdDp;
      notasExamenes.push(notaTmp)
      if(this.activarExamenExtraordinarioDp){
        extraordinarioTmp.tipoNota = "EX";
        extraordinarioTmp.ponderacionBaseId = this.ponderacionIdDp;
        notasExtraordinario.push(extraordinarioTmp);
      }
    });
    return {
      notasExamenes,
      notasExtraordinario
    }
  }

  guardar() {
    if (!this.validarPonderaciones()) {
      return
    }
    let notasParciales: Array<any> = []
    this.calificacionesParcialesDp.forEach((element, index) => {
      let notaTmp = this.fnNotaTmp(element, index)
      notasParciales.push(notaTmp)
    });
    let notasExamenes = this.fnNotasExamenes().notasExamenes
    let notasExtraordinario = this.fnNotasExamenes().notasExtraordinario
    const body: any = {
      configuracion: {
        anyo: this.filtroDp.anyo,
        periodoId: this.filtroDp.periodo.periodoAcademicoId,
        asignaturaId: this.filtroDp.asignatura.id,
        sedeId: this.filtroDp.sede.sedeId,
        seccionId: this.filtroDp.seccion.id,
        ponderacionBaseId: this.configDataDp.ponderacionBaseId
      },
      cantidadNotas: this.calificacionesParcialesDp.length,
      promedioNotas: notasParciales,
      cantidadExamenes: this.calificacionesExamenesDp.length,
      promedioExamenes: notasExamenes,
      examenExtraordinario: notasExamenes.length == 0 ? false : this.activarExamenExtraordinarioDp,
      promedioExamenesExtraordinario: this.activarExamenExtraordinarioDp ? notasExtraordinario : [],
      ponderacionPCP: this.ponderacionPCPDp,
      ponderacionPCET: this.ponderacionPCETPd
    }
    this._ponderaciones.modificarPonderacionIndividual(body).subscribe(
      (res: IResCrearPonderacion) => {
        if (res.error === null) {
          let configuracion = this.filtrosInicioDp
          this.router.navigate(['/ponderacion-individual-inicio'], { state: { data: { ponderacionEditada: true, configuracion: configuracion } } })
        } else if (res.codigo !== 200 && res.codigo !== 404) {
          this.infoModalTituloDp = 'Aviso'
          this.infoModalTextoDp = res?.error?.mensaje ? res.error.mensaje : 'Hubo un error en los servicios.'
          document.getElementById('btn-modal-info')?.click()
        }
      }
    )
  }
}
